import { render, staticRenderFns } from "./Inbound.vue?vue&type=template&id=b5a6864e&scoped=true"
import script from "./Inbound.vue?vue&type=script&lang=js"
export * from "./Inbound.vue?vue&type=script&lang=js"
import style0 from "./Inbound.vue?vue&type=style&index=0&id=b5a6864e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a6864e",
  null
  
)

export default component.exports